<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .note-creation {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);
    width: utils.in_rem(481px);

    margin-top: utils.in_rem(8px);
    margin-bottom: utils.in_rem(24px);

    > h3 {
      @include mixins.h3();
    }
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import SettingMultiDropdown from "../../../components/shared/SettingMultiDropdown.svelte";
  import { integrationStore } from "../../../stores";
  import CrmSpecificSettings from "./CrmSpecificSettings.svelte";

  $: allSettings = $integrationStore.getSettings("general");

  $: noteCreationSetting =
    allSettings?.find((setting) => setting.key === "createNotesUpon") || {};

  const filterSmsOptions = (item) =>
    !item?.toLowerCase?.().includes("sms") || $userStore?.hasSms;

  // Apply SMS filtering to the setting
  $: setting = {
    ...noteCreationSetting,
    values: noteCreationSetting.values?.filter((opt) =>
      filterSmsOptions(opt.val)
    ),
  };
</script>

<div class="note-creation">
  <h3>Note creation</h3>
  <SettingMultiDropdown {setting} />
  <CrmSpecificSettings />
</div>
